// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"374":"aa5ff968c2409643","432":"012b235945cf2d45"}[chunkId] + ".js";
};